module.exports = __webpack_public_path__ + "img/healing _all.1c8fe9a8.png";